import { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Spinner } from '@codex/basics';

import BottomPopup from './BottomPopup';
import TopInfoTable from './presentionalComponents/TopInfoTable';
import TechnicalSpecificationsTable from './presentionalComponents/TechnicalSpecificationsTable';
import { normalizeProductsDataForTechnicalSpecificationsTable } from '../../dataConverters/comparePopupConverter';


const SpinnerContainer = styled.div`
  position: absolute;
  height: 100%;
  left: 50%;
  transform: translate(-50%, -15%);
`;
const StickyTableWrapper = styled.div`
  top: 0; 
  margin: 0 5%;
  position: absolute; // fallback for IE11
  position: sticky;
  z-index: 1
`;

const TableWrapper = styled.div`
  margin: 0 5%;
  padding-bottom: 20px;
`;


const ComparePopupContainer = (
  { compareProductsData, loading, removeProductFromComparePopup,
    addProductToBasketFromComparePopup, addingProductToBasket, removeAllProductsFromComparePopup }) => {

  const productIds = compareProductsData
    ? compareProductsData.productsBasicInfo.map((productInfo) => productInfo.productId)
    : [];

  const [highlightRowsWithDifferentValues, setHighlightRowsWithDifferentValues] = useState(false);

  return (
    <>
      <BottomPopup
        visible={loading || Boolean(compareProductsData)}
        /* TODO: add to translations */
        title={!loading && productIds.length > 1
          ? `Compare Products (${productIds.length} of 4)`
          : 'Loading products data'}
        productIds={productIds}
        beforeClose={removeAllProductsFromComparePopup}
      >
        {loading && <SpinnerContainer><Spinner /></SpinnerContainer>}
        {!loading && compareProductsData && (
          <>
            <StickyTableWrapper>
              <TopInfoTable
                productInfoList={compareProductsData.productsBasicInfo}
                isShowDifferencesOnOffSwitchActive={highlightRowsWithDifferentValues}
                onShowDifferencesOnOffSwitchClick={() => {
                  setHighlightRowsWithDifferentValues(!highlightRowsWithDifferentValues);
                }}
                onRemoveButtonClick={(productRankInComparePopup) => {
                  removeProductFromComparePopup(
                    productRankInComparePopup, productIds[productRankInComparePopup]
                  );
                }}
                onAddToBasketButtonClick={addProductToBasketFromComparePopup}
                addingProductToBasket={addingProductToBasket}
              />
            </StickyTableWrapper>
            <TableWrapper>
              <TechnicalSpecificationsTable
                productTechRequirementsList={
                  normalizeProductsDataForTechnicalSpecificationsTable(compareProductsData.productsTechnicalSpecificationsInfo)
                }
                highlightRowsWithDifferentValues={highlightRowsWithDifferentValues}
              />
            </TableWrapper>
          </>
        )}
      </BottomPopup>
    </>
  );
};

ComparePopupContainer.propTypes = {
  loading: PropTypes.bool.isRequired,
  compareProductsData: PropTypes.shape({
    productsBasicInfo: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
    productsTechnicalSpecificationsInfo: PropTypes.array.isRequired // eslint-disable-line react/forbid-prop-types
  }),
  removeProductFromComparePopup: PropTypes.func.isRequired,
  removeAllProductsFromComparePopup: PropTypes.func.isRequired,
  addProductToBasketFromComparePopup: PropTypes.func.isRequired,
  addingProductToBasket: PropTypes.shape({
    productId: PropTypes.string,
    inProgress: PropTypes.bool,
    errorMessage: PropTypes.string
  })
};

ComparePopupContainer.defaultProps = {
  compareProductsData: undefined,
  addingProductToBasket: null
};

export default ComparePopupContainer;
